// extracted by mini-css-extract-plugin
module.exports = {"button":"button--3DJ6z","automatedTag":"automatedTag--XWa3-"};